module.exports = __webpack_public_path__ + "res/img/female.1dabd625.png";